__turbopack_context__.v({
  "action": "sca1Oq_action",
  "articleActions": "sca1Oq_articleActions",
  "articleBody": "sca1Oq_articleBody",
  "articleDeck": "sca1Oq_articleDeck",
  "articleGrid": "sca1Oq_articleGrid",
  "articleHeader": "sca1Oq_articleHeader",
  "articleTitle": "sca1Oq_articleTitle",
  "browse": "sca1Oq_browse",
  "browseHeader": "sca1Oq_browseHeader",
  "byline": "sca1Oq_byline",
  "caseAuthor": "sca1Oq_caseAuthor",
  "caseBio": "sca1Oq_caseBio",
  "caseGrid": "sca1Oq_caseGrid",
  "caseHeader": "sca1Oq_caseHeader",
  "caseHeaderGrid": "sca1Oq_caseHeaderGrid",
  "caseHero": "sca1Oq_caseHero",
  "caseProfile": "sca1Oq_caseProfile",
  "contents": "sca1Oq_contents",
  "desktopContents": "sca1Oq_desktopContents",
  "faq": "sca1Oq_faq",
  "feature": "sca1Oq_feature",
  "featureArtwork": "sca1Oq_featureArtwork",
  "filters": "sca1Oq_filters",
  "indexHeader": "sca1Oq_indexHeader",
  "label": "sca1Oq_label",
  "mobileContents": "sca1Oq_mobileContents",
  "muted": "sca1Oq_muted",
  "nextActions": "sca1Oq_nextActions",
  "nextStep": "sca1Oq_nextStep",
  "page": "sca1Oq_page",
  "postArt": "sca1Oq_postArt",
  "postCard": "sca1Oq_postCard",
  "postCollection": "sca1Oq_postCollection",
  "postCopy": "sca1Oq_postCopy",
  "primaryAction": "sca1Oq_primaryAction",
  "prose": "sca1Oq_prose",
  "rail": "sca1Oq_rail",
  "related": "sca1Oq_related",
  "relatedArt": "sca1Oq_relatedArt",
  "relatedGrid": "sca1Oq_relatedGrid",
  "resultCount": "sca1Oq_resultCount",
  "rowCategory": "sca1Oq_rowCategory",
  "rowMeta": "sca1Oq_rowMeta",
  "search": "sca1Oq_search",
  "showMore": "sca1Oq_showMore",
  "table": "sca1Oq_table",
  "takeaways": "sca1Oq_takeaways",
  "technical": "sca1Oq_technical",
  "topline": "sca1Oq_topline",
});
